'use strict';

import {
    addObjectToLocalStorage,
    createElements,
    createHtmlElement,
    findSelectionAndCrmData,
    getObjectFromLocalStorage, moveAroundTheFloors,
    numberWithCommas, removeObjectFromLocalStorage, userPrevent
} from '../../functions';
import {
    createSearchResultsSortMenu,
    setResultsInTheHtmlList,
    sortArray, toggleClassFavoritesInSearch
} from './search';
import { intersectionClickHandler } from '../threejs/raycast';
import { openOptionsCard, setWidthOfCardDependingOnMenu } from '../cards/optionsCards';
import { changeLangToCurrent, getCurrentLang } from '../language/langSwitcher';
import {dataArrayOfFlat} from "../cards/cardsConfig";
import {addFavoritesBlock} from "../cards/cardsFunctions";
import {CardTypes} from "../../common";
import {analytics} from "../analytics/analytics";
import Swiper, {Pagination, Navigation} from "swiper";
import 'swiper/swiper-bundle.min.css';
import {
    Buildings,
    cardsData,
    isMobile,
    projectMode,
    settingsData,
    threeJsVariables,
} from '../../settings';
import {getPropType} from "../cards/unitCards/unitCardFunctions";

export function findSimilarApartments (optionCardContainer = document.querySelector(`.${CardTypes.Options}-card__data`) ) {
    // const crmData = activeBuilding.crm_data;
    const result = {};
    const totalResultInOneBuilding = 5;

    const clickedApt = settingsData.lastClickedFlat.userData.crm_data;
    const price = clickedApt.salePrice;
    const roomNumber = clickedApt.roomNum;
    const exposure = clickedApt.facing;

    if (price === 0){
        Object.values(Buildings.buildings).forEach((building,index) =>{

           if (!building.getInfo()) return;

           let filteredApts = building.info.crm_data.filter(apt => apt.status === 'Available' && apt.roomNum === roomNumber && apt.facing === exposure && apt !== clickedApt);

           filteredApts = sortArray('minmax', 'salePrice', filteredApts);

            if (filteredApts.length > totalResultInOneBuilding){
                filteredApts.length = totalResultInOneBuilding;
            }

            let towerName;

            if (Array.isArray(building.info.towerName)){
                towerName = building.info.towerName.find(el => el.lang === getCurrentLang()).value;
            } else {
                towerName = building.info.towerName;
            }

            result[towerName] = filteredApts;
        });
        // result = crmData.filter(apt => apt.status === 'Available' && apt.roomNum === roomNumber && apt.facing === exposure && apt !== clickedApt);
    } else {
        const minPrice = price;
        const maxPrice = price * 1.2;

        Object.values(Buildings.buildings).forEach((building,index) =>{

            if (!building.getInfo()) return;

            let filteredApts = building.info.crm_data.filter(apt => apt.status === 'Available' && (apt.salePrice >= minPrice && apt.salePrice <= maxPrice) && apt !== clickedApt);

            filteredApts = sortArray('minmax', 'salePrice', filteredApts);

            if (filteredApts.length > totalResultInOneBuilding){
                filteredApts.length = totalResultInOneBuilding;
            }

            let towerName;

            if (Array.isArray(building.info.towerName)){
                towerName = building.info.towerName.find(el => el.lang === getCurrentLang()).value;
            } else {
                towerName = building.info.towerName;
            }

            result[towerName] = filteredApts;
        });

        // result = crmData.filter(apt => apt.status === 'Available' && (apt.salePrice >= minPrice && apt.salePrice <= maxPrice) && apt !== clickedApt);
    }

    // result = sortArray('minmax', 'salePrice', result);

    // if (result.length === 0){
    //     return;
    // } else if (result.length > 5){
    //     result.length = 5;
    // }

    if (!checkResult(result)) return;

    const similarContainer = createHtmlElement(optionCardContainer,'','div',['similar__main__container']);


    if (isMobile && settingsData.isLandscape) {
        createSimilarAptList(result, similarContainer)
    } else {
        createSimilarAptCarousel(result, similarContainer);
    }
}

const createSimilarAptCarousel = (result, optionCardContainer) => {
    if (cardsData.cardMode.isAmenities) return;

    let showTitle = checkResult(result);

    showTitle && addTitle(optionCardContainer);
    const similarAptBlock = createElements('div', ['similar-apt', 'swiper'], optionCardContainer);
    const similarAptBlockWrapper = createElements('div', ['similar-apt__wrapper', 'swiper-wrapper'], similarAptBlock);

    Object.entries(result).forEach(([buildingName,apartments]) =>{
        apartments.forEach(apt =>{
            createCard(apt, similarAptBlockWrapper, buildingName);
        });

    });

    // result.forEach(apt => {
    //     createCard(apt, similarAptBlockWrapper);
    // })

    if (isMobile) {
        const pagination = createElements('div', ['swiper-pagination','similar-pagination'], similarAptBlock);

        Swiper.use([Pagination]);
        const swiper = new Swiper('.similar-apt', {
                direction: "horizontal",
                loop: false,
                slidesPerView: 1.3,
                spaceBetween: 20,
                pagination: {
                    el: '.similar-pagination',
                    type: 'bullets',
                },
            }
        );
    } else {
        //
        // if (result.length > 1) {
        const showButtons = checkResult(result);
        showButtons && addSwitchButtons(optionCardContainer, similarAptBlock);
        // }

        Swiper.use([Navigation]);
        const swiper = new Swiper('.similar-apt', {
                direction: "horizontal",
                loop: false,
                slidesPerView: 1.3,
                spaceBetween: 20,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            }
        );
    }
}

const checkResult = (result) => {
    for (const res of Object.values(result)) {
        if (res.length) {
            return true;
        }
    }
}

/**
 * CARDS CONSTRUCTOR
 */

const createCard = (crmDataObject, similarAptBlock, buildingName) => {
    const similarAptContainer = createElements('div', ['similar-apt__container', 'swiper-slide'], similarAptBlock, 'beforeend', {
        data: 'data-engineid',
        value: crmDataObject.engineId,
    });

    createHeader(crmDataObject, similarAptContainer, buildingName);
    createInfoPoints(crmDataObject, similarAptContainer);

    similarAptContainer.addEventListener('click', cardHandler);
    addFavoritesBlock(crmDataObject, similarAptContainer, 'similar-apt');
}

const createHeader = (crmDataObject, similarAptContainer, towerName) => {
    const similarAptHeader = createElements('div', ['similar-apt__header', 'card__header'], similarAptContainer);
    const similarAptTitleBox = createElements('div', ['similar-apt__title-box', 'card__title-box'], similarAptHeader);
    const similarAptSubtitle = createElements('div', ['similar-apt__subtitle-box', 'card__subtitle-box'], similarAptHeader);

    const similarAptTitle = createElements('h3', ['similar-apt__title', 'card__title'], similarAptTitleBox);

    const similarAptFlatName = createElements('span', ['similar-apt__name', 'card__title-flat-name', 'language-string'], similarAptTitle, 'beforeend', {
        data: 'data-dictionary',
        value: `${getPropType(crmDataObject.propType)}`
    });

    const similarAptFlatNumber = createElements('span', ['similar-apt__number', 'card__title-flat-number'], similarAptTitle);

    let similarAptTowerName = null;
    if (Buildings.getBuildingsInfoLength() > 1)
        similarAptTowerName = createElements('div', ['similar-apt__tower-name', 'card__tower-name'], similarAptSubtitle);

    const similarAptFloorNum = createElements('div', ['similar-apt__floor-number', 'card__floor-number'], similarAptSubtitle);
    const similarAptFloor = createElements('span', ['similar-apt__floor-number-floor', 'card__floor_floor', 'language-string'], similarAptFloorNum, 'beforeend', {
        data: 'data-dictionary',
        value: 'floor'
    });
    const similarAptNum = createElements('span', ['similar-apt__floor-number_num', 'card__floor_num'], similarAptFloorNum);

    similarAptFlatName.innerHTML = changeLangToCurrent(getPropType(crmDataObject.propType));
    similarAptFloor.innerHTML = changeLangToCurrent('floor');
    similarAptFlatNumber.innerHTML = crmDataObject.propNum;
    similarAptNum.innerHTML = crmDataObject.floorNum;

    const regExp = /[a-z\u0590-\u05fe]/gi;
    const isStringName = regExp.test(towerName);

    if (Buildings.getBuildingsInfoLength() > 1) {
        if (!isStringName) {
            let towerNumber =  similarAptSubtitle.querySelector('.similar-apt__tower-name_num');
            let towerTitle = similarAptSubtitle.querySelector('.similar-apt__tower-name_title');

            if (!towerNumber) {
                towerNumber = createElements('span', [`similar-apt__tower-name_num`, 'language-string'], similarAptTowerName, 'beforeend', {
                    data: 'data-dictionary',
                    value: 'building'
                });
                towerTitle = createElements('span', [`similar-apt__tower-name_title`], similarAptTowerName);
            }

            towerTitle.innerHTML = towerName;
            towerNumber.innerHTML = changeLangToCurrent('building')  + ' ';
        } else {
            similarAptTowerName.innerHTML = towerName;
        }
    }

    createPriceBlock(crmDataObject, similarAptTitleBox)
}

const createPriceBlock = (crmDataObject, similarAptTitleBox) => {
    const similarAptPrice = createElements('div', ['similar-apt__price', 'card__price'], similarAptTitleBox);

    const isPrice = crmDataObject.salePrice !== 0 && config.property.settings.displayPrice === 'show';
    const priceValue = createElements('span', [`similar-apt__price-value`, 'card__price-value'], similarAptPrice);
    const priceCurrency = createElements('span', [`similar-apt__price-currency`, 'card__price-currency', 'language-string'], similarAptPrice);

    // Create price block when price available
    if (isPrice) {
        const currencyLocal = config.localization.currencyLabel;
        priceCurrency.setAttribute('data-dictionary', currencyLocal);
        priceCurrency.innerHTML = changeLangToCurrent(currencyLocal);
        const price = numberWithCommas(Math.floor(crmDataObject.salePrice));
        priceValue.innerHTML = price;
    }

    if (crmDataObject.status !== "Available") {
        priceCurrency.setAttribute('data-dictionary', crmDataObject.status);
        priceCurrency.classList.add('language-string');
        priceCurrency.innerHTML = changeLangToCurrent(crmDataObject.status);
        priceValue.innerHTML = '';
    }

}

const createInfoPoints = (crmDataObject, similarAptContainer) => {

    const cardsInfo = dataArrayOfFlat(crmDataObject);
    const infoPointsData = cardsInfo.filter(data => {
        if ( config.features.apartments.aptCardFieldsCntUnit.indexOf(data.name) !== -1) {
            return data;
        }
    })

    const regExp = /([A-Za-z])\w+/g;
    const measurement = config.localization.area ? config.localization.area : "m2";
    const similarAptInfoPoints = createElements('div', ['similar-apt__info-points', 'card__info-points'], similarAptContainer);

    infoPointsData.forEach(data => {
        if (+data.data === 0) return;

        const cardContentWrapper = createElements('div', [`similar-apt-card__info-points-wrapper`, 'card__info-points-block-wrapper'], similarAptInfoPoints);
        const cardModelName = createElements('div', [`similar-apt-card__info-points-block_data`, 'card__info-points-block_data'], cardContentWrapper);
        const cardModelNameText = createElements('span', [`similar-apt-card__info-points-block_data_text`, 'card__info-points-block_data_text', 'language-string'], cardModelName, 'beforeend', {
            data: 'data-dictionary',
            value: data.data,
        });
        const contentSubtext = createElements('div', [`similar-apt-card__info-points-block_subtitle`, 'card__info-points-block_subtitle'], cardContentWrapper);

        if (regExp.test(data.data)) {
            cardModelNameText.style.direction = "ltr";
        }

        contentSubtext.innerHTML += `<span class="language-string" data-dictionary="${data.name}">${changeLangToCurrent(data.name)}</span>`;
        if (data.name === 'area') {
            const coma = `<span>,</span>`;
            contentSubtext.innerHTML += coma;
            const measurementTag = createElements('span', ['language-string', 'card__info-points-block_subtitle-measurement'], contentSubtext, 'beforeend', {
                data: 'data-dictionary',
                value: measurement,
            });
            measurementTag.innerHTML += changeLangToCurrent(measurement);
            measurementTag.classList.add('meters');
        }

        cardModelNameText.innerHTML = changeLangToCurrent(data.data);
        cardModelName.classList.add(data.icon);
    });
}

const addTitle = (optionCardContainer) => {
    const text = createHtmlElement(optionCardContainer, changeLangToCurrent('similarApartmentsTitle'),'h4',['similar__text','language-string']);
    text.setAttribute('data-dictionary','similarApartmentsTitle');
}

/**
 * CREATE SWITCH BLOCK
 */

const addSwitchButtons = (parent) => {
    const switcherBlock = createElements('div', [`similar-switcher-block`, 'card__switcher-block'], parent);

    const prevButton = createElements('button', ['icon-left1', 'swiper-button-prev'], switcherBlock);
    const nextButton = createElements('button', ['icon-right1', 'swiper-button-next'], switcherBlock);
}
/**
 * CLICK HANDLER
 */
const cardHandler = async (e) => {
    if (userPrevent()) return;
    e.stopPropagation();

    let element = e.target.getAttribute('data-engineid');

    if (e.target.classList.contains('similar-apt-card__favorite-label') || e.target.classList.contains('similar-apt-card__favorite-checkbox')) return;

    element = e.target.closest('.similar-apt__container');
    element = element.getAttribute('data-engineid');

    const buildingInfo = Buildings.getBuilding(element.split('_')[0]);
    const activeBuilding = Buildings.getActiveBuilding();

    const aptMesh = threeJsVariables.scene.getObjectByName(element);

    // if (settingsData.buildingDestroyed) {
    //     const {selectedMesh} = findSelectionAndCrmData(element);
    //     settingsData.lastClickedFlat = selectedMesh;
    //     await moveAroundTheFloors(element)
    //     // if (settingsData.currentFloor !== aptMesh.userData.floor) {
    //     //     floorChange(aptMesh.userData.floor,  settingsData.currentFloor, true)
    //     //     settingsData.currentFloor = aptMesh.userData.floor;
    //     //     flatLabelsUpdate(settingsData.currentFloor);
    //     //     changeSliderActiveBtn(settingsData.currentFloor);
    //     //     actionForFirstAndLastFloors(settingsData.currentFloor)
    //     // }
    // }
    if (buildingInfo.name === activeBuilding.name){

        if (settingsData.buildingDestroyed) {
            // if (settingsData.currentFloor !== aptMesh.userData.floor) {
            //     floorChange(aptMesh.userData.floor,  settingsData.currentFloor, true);
            //     // settingsData.currentFloor = aptMesh.userData.floor;
            //     // flatLabelsUpdate(settingsData.currentFloor);
            //     // changeSliderActiveBtn(settingsData.currentFloor);
            //     // actionForFirstAndLastFloors(settingsData.currentFloor)
            // }

            const {selectedMesh} = findSelectionAndCrmData(element);
            settingsData.lastClickedFlat = selectedMesh;
            await moveAroundTheFloors(element)
        }

       await intersectionClickHandler(aptMesh);

        // setTimeout(()=>{
            openOptionsCard(aptMesh.userData.crm_data,config,{
                disableAnimation: true
            });
            !isMobile && setWidthOfCardDependingOnMenu();
        // },500)

    } else {

        if (settingsData.buildingDestroyed){
            await projectMode.FloorPlan.exitFromMode();
            await projectMode.Cylinder.switchBuilding(buildingInfo);
            // cylinderModeHandler('fromDestroy');
        } else {
            await projectMode.Cylinder.switchBuilding(buildingInfo);
        }

        // setTimeout(()=>{

            await intersectionClickHandler(aptMesh);

            // setTimeout(()=>{
                openOptionsCard(aptMesh.userData.crm_data,config,{
                    disableAnimation: true
                });
                !isMobile && setWidthOfCardDependingOnMenu();
            // },500)
        // },300);
    }
};

/**
 * ADD/REMOVE FAVORITES
 */

export const similarFavoriteHandle = (e) => {
    let card, dataEngineID;
    let label;

    if (e.target.tagName === 'LORD-ICON'){
        label = e.target.parentElement;
    } else {
        label = e.target;
    }

    label.classList.toggle('icon-favorite_selected');
    label.classList.toggle('icon--lord-unselected');

    card = e.target.closest('.similar-apt__container');
    dataEngineID = card.getAttribute('data-engineid');

    const {crmDataOfFlat} = findSelectionAndCrmData(dataEngineID);
    const storageData = getObjectFromLocalStorage(crmDataOfFlat.engineId);

    storageData ? removeObjectFromLocalStorage(crmDataOfFlat) : addObjectToLocalStorage(crmDataOfFlat);
    const target = findTargetOfSearch(dataEngineID);

    if (target){

        toggleClassFavoritesInSearch(target, storageData, true);
    }

    analytics('favorites', {storageData, crmDataOfFlat});
}

const findTargetOfSearch = (dataEngineID) => {
    const searchList = document.querySelectorAll('.search__result-item');
    let targetLi, targetSpan;
    searchList.forEach(elem => {
        if (elem.getAttribute('data-engineid') === dataEngineID) {
            targetLi = elem;
        }
    });

    targetSpan = targetLi?.querySelector('span[data-favorite=favorite]');

    return targetSpan;
}

export const recreateBlockWhenLangSwitch = () => {
    document.querySelector('.similar__text')?.remove();

    document.querySelector('.similar-apt') && document.querySelector('.similar-apt')?.remove();
    document.querySelector('.similar-switcher-block') && document.querySelector('.similar-switcher-block')?.remove();
    document.querySelector('.similar-apt__container') && document.querySelector('.similar-apt__container')?.remove();

    findSimilarApartments();
}

/**
 * LIST OF APT
 */

const createSimilarAptList = (result, optionCardContainer) => {
    // const sortMenuItems = ['favorite','propNum','facing','floorNum','roomNum','totalSpace','salePrice'];
    const activeMenuItems = ['propNum','floorNum','roomNum','totalSpace','salePrice'];

    const container = createHtmlElement(optionCardContainer,'','div',['similar-apt__container']);
    const text = createHtmlElement(container,changeLangToCurrent('similarApartmentsTitle'),'h4',['similar__text','language-string']);
    text.setAttribute('data-dictionary','similarApartmentsTitle');
    const sort = createHtmlElement(container,'','div',['similar__sort']);
    const searchSortState = JSON.parse(JSON.stringify(config.features.search.searchSortState));

    const filteredMenuItems = searchSortState.filter(el => activeMenuItems.includes(el.type));
    filteredMenuItems.forEach(el =>el.isActive = false);

    createSearchResultsSortMenu(sort,filteredMenuItems,{
        template:{},
        disableListener: true,
    });

    const list = createHtmlElement(container,'','ul',['similar__result-list']);

    Object.entries(result).forEach(([buildingIndex,apartments]) =>{

        setResultsInTheHtmlList(apartments, list, {
            template: {
                favorite: false,
                aptNumber: true,
                exposure: false,
                floorNumber: true,
                roomNumber: true,
                totalSpace: true,
                price: true,
            },
            customClass: 'similar-item'
        });

    });


    list.addEventListener('click',listHandler);
}

function listHandler (e) {
    e.stopPropagation();

    console.log(e.target)
    let element;

    if (!e.target.classList.contains('similar-item')){
        element = e.target.closest('.similar-item');
    } else {
        element = e.target;
    }

    if (!element){
        return;
    }

    const aptMesh = threeJsVariables.scene.getObjectByName(element.getAttribute('data-engineid'));
    intersectionClickHandler(aptMesh);

    setTimeout(()=>{
        openOptionsCard(aptMesh.userData.crm_data,config,{
            disableAnimation: true
        });
        !isMobile && setWidthOfCardDependingOnMenu();
    },500)

}
